import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ServicesService } from 'services/ServicesService';
import { UGDService } from 'services/UGDService';

export const fetchMeasures = createAsyncThunk(
  'staticHandbooks/fetchMeasures',
  async (_, thunkAPI) => {
    try {
      const res = await axios.get('measures_crm/');

      if (res.status === 200) {
        return res.data;
      }
    } catch (err) {
      return thunkAPI.rejectWithValue([]);
    }
  }
);

export const fetchKNP = createAsyncThunk(
  'staticHandbooks/fetchKNP',
  async (_, thunkAPI) => {
    try {
      const res = await axios.get('knp-cache/select/');

      if (res.status === 200) {
        return res.data;
      }
    } catch (err) {
      return thunkAPI.rejectWithValue([]);
    }
  }
);

export const fetchBanks = createAsyncThunk(
  'staticHandbooks/fetchBanks',
  async (_, thunkAPI) => {
    try {
      const res = await axios.get('getallbank/');

      if (res.status === 200) {
        return res.data;
      }
    } catch (err) {
      return thunkAPI.rejectWithValue([]);
    }
  }
);

export const fetchPackages = createAsyncThunk(
  'staticHandbooks/fetchPackages',
  async (_, thunkAPI) => {
    try {
      const res = await ServicesService.getPackages({
        page: 1,
        perPage: 80,
      });

      return res.items;
    } catch (err) {
      return thunkAPI.rejectWithValue([]);
    }
  }
);

export const fetchUGD = createAsyncThunk(
  'staticHandbooks/fetchUGD',
  async (_, thunkAPI) => {
    try {
      const items = await UGDService.getAllUGD();
      return items;
    } catch (err) {
      return thunkAPI.rejectWithValue([]);
    }
  }
);

const initialState = {
  measuresData: {
    items: [],
    loading: false,
  },
  knpData: {
    items: [],
    loading: false,
  },
  banksData: {
    items: [],
    loading: false,
  },
  packagesData: {
    items: [],
    loading: false,
  },
  ugdData: {
    items: [],
    loading: false,
  },
};

const staticHandbooksReducer = createSlice({
  name: 'staticHandbooks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMeasures.fulfilled, (state, action) => {
      state.measuresData.items = action.payload;
      state.measuresData.loading = false;
    });
    builder.addCase(fetchMeasures.pending, (state) => {
      state.measuresData.loading = true;
    });
    builder.addCase(fetchMeasures.rejected, (state, action) => {
      state.measuresData.items = action.payload;
      state.measuresData.loading = false;
    });
    builder.addCase(fetchKNP.fulfilled, (state, action) => {
      state.knpData.items = action.payload;
      state.knpData.loading = false;
    });
    builder.addCase(fetchKNP.pending, (state) => {
      state.knpData.loading = true;
    });
    builder.addCase(fetchKNP.rejected, (state, action) => {
      state.knpData.items = action.payload;
      state.knpData.loading = false;
    });
    builder.addCase(fetchBanks.fulfilled, (state, action) => {
      state.banksData.items = action.payload;
      state.banksData.loading = false;
    });
    builder.addCase(fetchBanks.pending, (state) => {
      state.banksData.loading = true;
    });
    builder.addCase(fetchBanks.rejected, (state, action) => {
      state.banksData.items = action.payload;
      state.banksData.loading = false;
    });
    builder.addCase(fetchPackages.fulfilled, (state, action) => {
      state.packagesData.items = action.payload;
      state.packagesData.loading = false;
    });
    builder.addCase(fetchPackages.pending, (state) => {
      state.packagesData.loading = true;
    });
    builder.addCase(fetchPackages.rejected, (state, action) => {
      state.packagesData.items = action.payload;
      state.packagesData.loading = false;
    });
    builder.addCase(fetchUGD.fulfilled, (state, action) => {
      state.ugdData.items = action.payload;
      state.ugdData.loading = false;
    });
    builder.addCase(fetchUGD.pending, (state) => {
      state.ugdData.loading = true;
    });
    builder.addCase(fetchUGD.rejected, (state, action) => {
      state.ugdData.items = action.payload;
      state.ugdData.loading = false;
    });
  },
});

// export const {} = staticHandbooksReducer.actions;
export default staticHandbooksReducer.reducer;
